import _extends from "@babel/runtime/helpers/extends";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _createClass from "@babel/runtime/helpers/createClass";
import _inheritsLoose from "@babel/runtime/helpers/inheritsLoose";
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';
import Option from './Option';
import './SearchOrCreate.less';
import './Option.less';

var searchImg = require('../media/registration-existing-user.png');

var searchActiveImg = require('../media/registration-existing-user-active.png');

var newImg = require('../media/registration-new-user.png');

var newActiveImg = require('../media/registration-new-user-active.png');

var SEARCH = 'search';
var CREATE = 'create';

var SearchOrCreate = /*#__PURE__*/function (_Component) {
  _inheritsLoose(SearchOrCreate, _Component);

  _createClass(SearchOrCreate, null, [{
    key: "SEARCH",
    get: function get() {
      return SEARCH;
    }
  }, {
    key: "CREATE",
    get: function get() {
      return CREATE;
    }
  }, {
    key: "propTypes",
    get: function get() {
      return {
        onChange: PropTypes.func,
        selectedOption: PropTypes.string,
        searchLabel: PropTypes.node,
        searchPanelId: PropTypes.string,
        searchIcon: PropTypes.node,
        searchIconSelected: PropTypes.node,
        searchEnabled: PropTypes.bool,
        createLabel: PropTypes.node,
        createPanelId: PropTypes.string,
        createIcon: PropTypes.node,
        createIconSelected: PropTypes.node,
        createEnabled: PropTypes.bool,
        extraOption: PropTypes.shape({
          id: PropTypes.string,
          panelId: PropTypes.string,
          icon: PropTypes.node,
          iconSelected: PropTypes.node,
          label: PropTypes.node,
          enabled: PropTypes.bool
        })
      };
    }
  }, {
    key: "defaultProps",
    get: function get() {
      return {
        searchLabel: 'Search Accounts',
        searchPanelId: 'search-panel',
        searchIcon: getImageTag(searchImg, 'Search existing'),
        searchIconSelected: getImageTag(searchActiveImg, 'Search existing'),
        searchEnabled: true,
        createLabel: 'Create New Account',
        createPanelId: 'create-panel',
        createIcon: getImageTag(newImg, 'Create'),
        createIconSelected: getImageTag(newActiveImg, 'Create'),
        createEnabled: true,
        selectedOption: SEARCH
      };
    }
  }]);

  function SearchOrCreate(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    _this.handleSelectionClick = _this.handleSelectionClick.bind(_assertThisInitialized(_this));
    _this.state = {
      selectedOption: props.selectedOption
    };
    return _this;
  }

  var _proto = SearchOrCreate.prototype;

  _proto.componentWillReceiveProps = function componentWillReceiveProps(_ref) {
    var selectedOption = _ref.selectedOption;

    if (typeof selectedOption !== 'undefined') {
      this.setState({
        selectedOption: selectedOption
      });
    }
  };

  _proto.handleSelectionClick = function handleSelectionClick(id) {
    this.selectedOption = id;
  };

  _proto.render = function render() {
    return /*#__PURE__*/React.createElement("div", {
      className: "search-or-create-container",
      role: "tablist"
    }, this.options);
  };

  _createClass(SearchOrCreate, [{
    key: "selectedOption",
    set: function set(option) {
      this.props.onChange(option);
      this.setState({
        selectedOption: option
      });
    }
  }, {
    key: "options",
    get: function get() {
      var options = [{
        id: SEARCH,
        panelId: this.props.searchPanelId,
        icon: this.props.searchIcon,
        iconSelected: this.props.searchIconSelected,
        label: this.props.searchLabel,
        enabled: this.props.searchEnabled,
        onClick: this.handleSelectionClick,
        selected: this.state.selectedOption === SEARCH
      }, {
        id: CREATE,
        panelId: this.props.createPanelId,
        icon: this.props.createIcon,
        iconSelected: this.props.createIconSelected,
        label: this.props.createLabel,
        enabled: this.props.createEnabled,
        onClick: this.handleSelectionClick,
        selected: this.state.selectedOption === CREATE
      }];

      if (!_.isUndefined(this.props.extraOption)) {
        var extraOption = _extends({}, this.props.extraOption, {
          onClick: this.handleSelectionClick,
          selected: this.state.selectedOption === this.props.extraOption.id
        });

        options.push(extraOption);
      }

      return _.map(options, function (option) {
        return /*#__PURE__*/React.createElement(Option, _extends({
          key: option.id
        }, option));
      });
    }
  }]);

  return SearchOrCreate;
}(Component);

export { SearchOrCreate as default };
export var getImageTag = function getImageTag(url, altText) {
  return /*#__PURE__*/React.createElement("img", {
    src: url,
    alt: altText,
    className: "search-or-create-option-icon",
    "aria-hidden": "true"
  });
};